import { t } from "i18next";
import { useCallback, useState } from "react";
import { ALLOWED_AUDIO_MIME_TYPES, MAX_AUDIO_MB } from "@/common/config";
import { bytesToMegabytes } from "@/lib/utils";

interface UseAudioValidation {
  error: string | null;
  validateFile: (file: File) => boolean;
  resetError: () => void;
}

export const useAudioValidation = (): UseAudioValidation => {
  const [error, setError] = useState<string | null>(null);
  const validateFile = (file: File): boolean => {
    const sizeMB = bytesToMegabytes(file.size);
    const isValidSize = sizeMB < MAX_AUDIO_MB;
    const isValidType = ALLOWED_AUDIO_MIME_TYPES.includes(file.type);
    if (!isValidSize) {
      setError(
        t("error.formRecorder.maximumSize", {
          MAX_AUDIO_MB: MAX_AUDIO_MB.toFixed(1),
        }),
      );
      return false;
    }
    if (!isValidType) {
      setError(t("error.formRecorder.unsupportedFormat"));
      return false;
    }
    setError(null);
    return true;
  };

  // Stable: the new-visit sidebar's close effect depends on it.
  const resetError = useCallback((): void => {
    setError(null);
  }, []);

  return { error, validateFile, resetError };
};
